import React from "react";

// Renders text and colors "Prime" gold within any "MedPrime" occurrence,
// so the brand wordmark looks consistent everywhere it appears.
export function BrandText({ children }) {
  const text = typeof children === "string" ? children : String(children ?? "");
  const parts = text.split(/(MedPrime)/g);
  return (
    <>
      {parts.map((part, i) =>
        part === "MedPrime" ? (
          <span key={i} className="whitespace-nowrap">
            Med<span className="text-gold">Prime</span>
          </span>
        ) : (
          <React.Fragment key={i}>{part}</React.Fragment>
        )
      )}
    </>
  );
}
